import { useCallback } from 'react';
import queryString from 'query-string';
import { PrimitiveAtom, atom, useSetAtom } from 'jotai';
import { useFilterSyncWithParms } from '@/hooks/useFilterSyncWithParms';

type TemplateFilter = { id: string; value: string[] };

const noopAtom = atom<TemplateFilter[]>([]);

export type FiltersDeeplinkState = {
  shouldUpdateUrl: boolean;
  selectedTemplateFiltersAtom?: PrimitiveAtom<TemplateFilter[]>;
};

export const useFiltersDeeplink = (state: FiltersDeeplinkState) => {
  // useFilterSyncWithParms handles its own URL reading internally
  // it handles templateFilters parameter
  useFilterSyncWithParms();

  const setSelectedTemplateFilters = useSetAtom(state.selectedTemplateFiltersAtom ?? noopAtom);

  const applyFromParsed = useCallback(
    (parsed: queryString.ParsedQuery<string>) => {
      if (!state.selectedTemplateFiltersAtom) return;
      if (!parsed.filters) return;
      const filters = JSON.parse(parsed.filters.toString());
      const mapped = filters.map(({ id, o }: { id: string; o: string[] }) => ({
        id,
        value: [...o],
      }));
      setSelectedTemplateFilters(mapped);
    },
    [state.selectedTemplateFiltersAtom, setSelectedTemplateFilters]
  );

  return { applyFromParsed };
};
